import { type Pager, type PagerQueryRequest } from '../types';

export default function pagerDeserializer(data: Pager): PagerQueryRequest {
  return {
    ps: data?.limit === 'all' ? -1 : data?.limit,
    rs: data?.limit === 'all' ? 0 : data?.offset,
  };
}
